"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Select = _interopRequireDefault(require("@cimpress/react-components/lib/Select"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var formats = _interopRequireWildcard(require("../formats"));

var options = [{
  label: 'Excel Workbook (*.xlsx)',
  value: formats.XLSX_FORMAT
}, {
  label: 'Excel 97-2003 Workbook (*.xls)',
  value: formats.XLS_FORMAT
}, {
  label: 'CSV (Comma delimited) (*.csv)',
  value: formats.CSV_FORMAT
}, {
  label: 'JSON (*.json)',
  value: formats.JSON_FORMAT
}];

var FileTypeInput =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(FileTypeInput, _PureComponent);

  function FileTypeInput() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, FileTypeInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(FileTypeInput)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChange", function (option) {
      var onChange = _this.props.onChange;

      if (option) {
        var value = option.value;
        onChange && onChange(value);
      }
    });
    return _this;
  }

  (0, _createClass2.default)(FileTypeInput, [{
    key: "render",
    value: function render() {
      var value = this.props.value;
      return _react.default.createElement(_Select.default, {
        backspaceRemoves: false,
        clearable: false,
        label: "Save as",
        options: options,
        tether: true,
        value: value,
        onChange: this.onChange
      });
    }
  }]);
  return FileTypeInput;
}(_react.PureComponent);

exports.default = FileTypeInput;
(0, _defineProperty2.default)(FileTypeInput, "propTypes", {
  value: _propTypes.default.string.isRequired,
  onChange: _propTypes.default.func.isRequired
});